import React, {useContext} from 'react';
import {classes, style} from './doppe-action-type-widget-content-layout-new.st.css';
import {
    DoppeActionTypeWidgetContentSection
} from '../doppe-action-type-widget-content-section/doppe-action-type-widget-content-section';
import {Values} from '@wix/devzai-utils-common';
import {DoppeViewerScrollView} from '../doppe-viewer-scroll-view/doppe-viewer-scroll-view';
import {FlexLayout} from '@wix/devzai-common-client';
import {ScrollViewScrollingDirection} from '@wix/devzai-utils-react';
import {DoppeActionTypeWidgetLayoutContext} from '../doppe-action-type-widget-layout/doppe-action-type-widget-layout';

export const DoppeActionTypeWidgetContentLayoutContentAlignment = {
    Default: 'default',
    Center: 'center'
} as const;

export type DoppeActionTypeWidgetContentLayoutContentAlignment = Values<typeof DoppeActionTypeWidgetContentLayoutContentAlignment>;

export const DoppeActionTypeWidgetContentLayoutNew = React.memo(function DoppeActionTypeWidgetContentLayoutNew (props: DoppeActionTypeWidgetContentLayoutNew.Props) {
    const {
        children,
        footer,
        mainMedia,
        fullWidthMainMedia = false,
        contentAlignment = DoppeActionTypeWidgetContentLayoutContentAlignment.Default,
        isFixedHeight = false,
        noContentPadding = false,

        className,
        ...htmlAttributes
    } = props;


    const doppeActionTypeWidgetLayoutContext = useContext(DoppeActionTypeWidgetLayoutContext)

    const forceMaxHeight = doppeActionTypeWidgetLayoutContext?.forceMaxHeight ?? false;
    const headerSpec = doppeActionTypeWidgetLayoutContext?.headerSpec ?? null;
    const isStrip = doppeActionTypeWidgetLayoutContext?.isStrip ?? false;

    const shouldRenderMainMediaInFullWidth = isStrip ? false : fullWidthMainMedia;

    const content = (
        <>
            {mainMedia ? (
                shouldRenderMainMediaInFullWidth ?
                    <div
                        className={style(classes.mainMediaContainer, {})}
                    >
                        {mainMedia}
                    </div>
                    :
                    <DoppeActionTypeWidgetContentSection>
                        <div
                            className={style(classes.mainMediaContainer, {})}
                        >
                            {mainMedia}
                        </div>
                    </DoppeActionTypeWidgetContentSection>
            ) : null}
            <DoppeActionTypeWidgetContentSection
                noPadding={noContentPadding}
                className={style(classes.content)}
            >
                {children}
            </DoppeActionTypeWidgetContentSection>
        </>
    );

    return (
        <div
            {...htmlAttributes}
            className={style(
                classes.root,
                {
                    hasFooter: !!footer,
                    hasMainMedia: !!mainMedia,
                    contentAlignment: contentAlignment,
                    fullWidthMainMedia: shouldRenderMainMediaInFullWidth,
                    isFixedHeight: isFixedHeight,
                    noContentPadding: noContentPadding,
                    forceMaxHeight: forceMaxHeight,
                    hasHeader: headerSpec !== null,
                    hasHeaderWithBottomBorder: headerSpec?.hasBorderBottom ?? false
                },
                className
            )}
        >
            {
                isFixedHeight ?
                    <DoppeViewerScrollView
                        className={style(classes.scrollView, {}, FlexLayout.fillRemainingVerticalSpace)}
                        scrolledContentWrapperClassName={style(classes.innerScrollContent, {}, FlexLayout.column.default)}
                        scrollingDirection={ScrollViewScrollingDirection.Vertical}
                    >
                        {content}
                    </DoppeViewerScrollView>
                    :
                    content
            }
            {footer ? (
                <DoppeActionTypeWidgetContentSection
                >
                    <div
                        className={style(classes.footerContent, {})}
                    >
                        {footer}
                    </div>
                </DoppeActionTypeWidgetContentSection>
            ) : null}
        </div>
    );
});

export namespace DoppeActionTypeWidgetContentLayoutNew {

    export interface Props extends React.HTMLAttributes<any> {
        footer?: React.ReactNode;
        mainMedia?: React.ReactNode;
        fullWidthMainMedia?: boolean;
        isFixedHeight?: boolean;
        contentAlignment?: DoppeActionTypeWidgetContentLayoutContentAlignment;
        noContentPadding?: boolean;
    }
}
